/**
 * 사이트 안내사항 전용 파일
 * 운영자가 문구 수정 시 이 파일만 수정하면 됨
 */

export const NOTICE = {
  intro: `
에키온 DB는 에키온의 통계 및 데이터 분석을 위한 사이트입니다.

이 사이트는 개인 전적 조회를 주목적으로 하는 사이트가 아니며, 
에키온의 무기별 성능, 아이템 선택률, 승률, 빌드 정보 등을 확인할 수 있도록 제작되었습니다.

시뮬레이터 기능은 현재 Beta 버전으로 제공되고 있으며, 일부 수치 또는 계산식에 오류가 있을 수 있습니다.

오류 제보, 문의사항, 개선 의견은 아래 디스코드 서버를 통해 전달해 주시기 바랍니다.
  `,

  watchlist: `
현재 이터널 리턴 Open API 구조상 랭킹 1000위 이후 유저의 플레이 이력은 자동으로 수집되지 않습니다.

추적을 원하거나 통계에서 제외가 필요한 유저가 있다면 디스코드를 통해 닉네임을 알려주시면 반영을 검토하겠습니다.
`,

  metapoint: `
MetaPoint는 현재 패치 기준 에키온 무기의 평균 RP, 승률, 평균 TK, 평균 순위, 픽률을 종합하여 계산한 자체 평가 지표입니다.
`,

  rpTop: `
MVP는 현재 선택된 패치 기준으로 일정 횟수 이상 해당 무기를 플레이한 유저만 대상으로 계산됩니다.
RP 획득량은 최근 전적에 표시되는 RP 증감값(matches.rp_change)의 합계를 기준으로 계산됩니다.
`,

  patchInfo: "",
  simulatorInfo: "",
  discord: {
    label: "Discord 문의",
    url: "https://discord.gg/p8q9Px4EY",
  },
};
